import React, {useContext, useEffect} from "react";
import { AppContext } from "../AppProviderDesktop";
import OfficeSelect from "../../design/OfficeSelect";


const FilterFlightsHead = React.memo(({data, setData, onClickSend, dataFromSumA}) => {
    // console.log("FilterFlightsHead");

    const {aufaData} = useContext(AppContext);

    useEffect(() => {
        // console.log("FilterFlightsHead - useEffect");

        // console.log("data", data, "dataFromSumA", dataFromSumA);
        if ('name' in dataFromSumA && dataFromSumA['name']) {

            setData({
                office: "*", 
                project: Object.keys(aufaData).find(key => 
                    aufaData[key].name === dataFromSumA["project"]
                ),
                type: dataFromSumA["flight"] ? "flights" : "cars",
                status: "*",
                name: dataFromSumA["name"],
            })

            onClickSend();
        }

    }, [dataFromSumA])

    return (
        <div className={"InvoicesListFilter"}>
            <p>משרד</p>
            <OfficeSelect 
            value={data.office}
            setValue={(o) => setData({...data, office: o})}
            />

            <p>פרוייקט</p>
            <select value={data.project} onChange={(e) => setData({...data, project: e.target.value})}>
                <option value={""} key={0}></option>

                {
                    Object.keys(aufaData).map((keyAufaData, key) => (
                        <option value={keyAufaData} key={key + 1}> {aufaData[keyAufaData]["name"]} </option>
                    ))
                }
            </select>

            <p>סוג</p>
            <select value={data.type} onChange={(e) => setData({...data, type: e.target.value})}>
                <option value={"flights"} key={1}>טיסה</option>
                <option value={"cars"} key={2}>נ"פ</option>
            </select>

            <p>שם טיסה</p>
            <select value={data.name} onChange={(e) => setData({...data, name: e.target.value})}>
                <option value={""} key={0}></option>

                {
                    data.project in aufaData && aufaData[data.project][data.type].map((keyData, key) => (
                        <option key={key} value={keyData}> {keyData} </option>
                    ))
                }
            </select>

            <p>סטטוס</p>
            <select value={data.status} onChange={(e) => setData({...data, status: e.target.value})}>
                <option value={"*"}>הכל</option>
                <option value={1}>אושר</option>
                <option value={0}>ממתין</option>
            </select>

            <div onClick={onClickSend}>
                <p className={"InvoicesListFilterSend"}>שליחה</p>
            </div>
        </div>
    )
})

export default FilterFlightsHead;